var React = require('react');

function DragArrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"data-name":"Path 276","d":"M37.149 16.044l7.668-7.669L37.149.707","fill":"none","stroke":"#d5651b","strokeWidth":"2","key":0}),React.createElement("path",{"data-name":"Line 20","fill":"none","stroke":"#d5651b","strokeWidth":"2","d":"M45 8.577H0","key":1})]);
}

DragArrow.defaultProps = {"viewBox":"0 0 46.231 16.751"};

module.exports = DragArrow;

DragArrow.default = DragArrow;
